import axios from "axios";
import { keycloak } from "../../lib/keycloak";
import { SotService } from "./service";
import { headQuarterResponseDTO, SOTCreationUpdateDTO, sotFilterDTO } from "./dto";

export class SotServiceImpl implements SotService {

    public CreateSOT(data: SOTCreationUpdateDTO): Promise<void> {
        return axios.post("/api/head-quarter",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateSOT(data: SOTCreationUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/head-quarter/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public RemoveSOT(id: string): Promise<void> {
        return axios.put("/api/head-quarter/remove/" + id,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public RestoreSOT(id: string): Promise<void> {
        return axios.put("/api/head-quarter/restore/" + id,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteSOT(id: string): Promise<void> {
        return axios.delete("/api/head-quarter/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetHeadQuarter(filters: sotFilterDTO): Promise<void> {
        return axios.get("/api/head-quarter", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                order: filters.order
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public FindSotById(id: string): Promise<headQuarterResponseDTO> {
        return axios.get("/api/head-quarter/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

}
